/**
 * 책 관련 공통 유틸리티 함수
 */

/**
 * 책의 총 읽은 페이지 수 계산
 * @param {Object} book - 책 객체
 * @returns {number} 총 읽은 페이지 수
 */
export const calculateTotalReadPages = (book) => {
  if (!book) return 0;
  const historySum = Object.values(book.readingHistory || {}).reduce((sum, pages) => sum + pages, 0);
  return historySum + (book.initialPage || 0);
};

/**
 * 책의 진행률 계산 (0-100)
 * @param {Object} book - 책 객체
 * @returns {number} 진행률 (%)
 */
export const calculateBookProgress = (book) => {
  if (!book || !book.totalPages) return 0;
  const totalReadPages = calculateTotalReadPages(book);
  return Math.round((totalReadPages / book.totalPages) * 100);
};

/**
 * 특정 날짜의 독서량 조회
 * @param {Object} book - 책 객체
 * @param {string} date - YYYY-MM-DD 형식의 날짜
 * @returns {number} 해당 날짜의 읽은 페이지 수
 */
export const getReadingForDate = (book, date) => {
  if (!book || !book.readingHistory) return 0;
  return book.readingHistory[date] || 0;
};

/**
 * 책이 완독되었는지 확인
 * @param {Object} book - 책 객체
 * @returns {boolean} 완독 여부
 */
export const isBookCompleted = (book) => {
  if (!book || !book.totalPages) return false;
  const totalReadPages = calculateTotalReadPages(book);
  return totalReadPages >= book.totalPages;
};

/**
 * 책의 남은 페이지 수 계산
 * @param {Object} book - 책 객체
 * @returns {number} 남은 페이지 수
 */
export const getRemainingPages = (book) => {
  if (!book || !book.totalPages) return 0;
  const totalReadPages = calculateTotalReadPages(book);
  return Math.max(0, book.totalPages - totalReadPages);
};
